/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Relatives from './relatives';
import RelativesDetail from './relatives-detail';
import RelativesUpdate from './relatives-update';
import RelativesDeleteDialog from './relatives-delete-dialog';

const RelativesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Relatives />} />
    <Route path="new" element={<RelativesUpdate />} />
    <Route path=":id">
      <Route index element={<RelativesDetail />} />
      <Route path="edit" element={<RelativesUpdate />} />
      <Route path="delete" element={<RelativesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RelativesRoutes;
